//@flow
import omit from 'lodash/omit'
import {initialState} from '$src/state'

import {
  type RequestAction,
  type RequestNameSpaceState,
  type AsyncErrorState,
} from '$src/requests/types'

export const requestReducer = (
  state: RequestNameSpaceState = initialState.requests,
  action: RequestAction
) => {
  switch (action.type) {
    case 'REQUEST/FAILURE':
    case 'REQUEST/SUCCESS':
      return omit(state, action.payload.omitKey)
    case 'REQUEST/START':
      return {
        ...state,
        [action.payload.key]: {requestKey: action.payload.requestKey},
      }
    default:
      return state
  }
}

export const asyncErrorReducer = (
  state: AsyncErrorState = initialState.asyncError,
  action: RequestAction
) => {
  switch (action.type) {
    case 'REQUEST/FAILURE':
      return action.payload.error
    case 'ERROR/CLEAR':
      return initialState.asyncError
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/requests/reducers.js